import React from 'react'
import { motion } from 'framer-motion'
import SolutionCard from './SolutionCard'
import roadsimg from '../../Assets/Home/Roads2.png'
import railwayimg from '../../Assets/Home/Railway1.png'
import tunnelimg from '../../Assets/Home/Tunnel4.png'
import urbanimg from '../../Assets/Home/Urbaninfra4.png'
import labimg from '../../Assets/Home/Labandmachin008.jpeg'


const OurSolution = () => {
  const data = [{
    img: roadsimg,
    name: "Roads, Highways & Expressways",
    description: "We present you a proposal and discuss niffty-gritty like",
    url: "Sectors/Roads-&-Bridges"
  }, {
    img: railwayimg,
    name: "Railways, Metros & Hydro Projects",
    description: "We present you a proposal and discuss niffty-gritty like",
    url: "Sectors/Railway"
  }, {
    img: tunnelimg,
    name: "Tunnel & Bridge",
    description: "We present you a proposal and discuss niffty-gritty like",
    url: "Sectors/Tunnels"
  },

  {
    img: urbanimg,
    name: "Urban & Smart City",
    description: "We present you a proposal and discuss niffty-gritty like",
    url: "Sectors/Urban-Infrastructure"
  },

 {
    img: labimg,
    name: "Lab and Machinery",
    description: "We present you a proposal and discuss niffty-gritty like",
    url: "Sectors/Lab-and-Machinery"
  }

]

  return (
    <div className='flex flex-col relative overflow-hidden bg-gradient-to-r mb-10 from-[#61ACCA] to-[#8364C3] mt-10'>
      <div className="oursolutionbg"></div>
      <div className='flex flex-col justify-center items-center py-10 gap-6 md:gap-10'>
        <div className='flex flex-col justify-center items-center gap-4'>
          <motion.p 
            className='max-sm:w-[60%] text-4xl md:text-4xl text-stone-800 text-center font-semibold experties-div'
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Area of <span className=' text-violet-200'>Expertise</span>
          </motion.p>
          <motion.p
            className='max-sm:w-[90%] text-sm md:text-md w-[60%] text-center text-white font-semibold '
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Connecting India with precision. For a decade, we’ve excelled in infrastructure consultancy, completing 1500+ projects worth 30K Crores across roads, highways, railways, bridge and tunnels. Trust us to bridge gaps and build the future.
          </motion.p>
        </div>
        <motion.div
          className='grid lg:grid-cols-5 sm:grid-cols-2 max-sm:grid-cols-1 max-sm:w-[80vw] py-4 max-sm:overflow-x-auto w-[90%] justify-center max-sm:justify-start gap-6'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {data.map((items, index) => (
            <SolutionCard
              key={items.name + index}
              img={items.img}
              name={items.name}
              url={items.url}
              description={items.description}
              index={index}
            />
          ))}
        </motion.div>
      </div>
    </div>
  )
}

export default OurSolution